import { render, staticRenderFns } from "./DocumentsCreateFormSidebar.vue?vue&type=template&id=89d16c20&scoped=true"
import script from "./DocumentsCreateFormSidebar.vue?vue&type=script&lang=js"
export * from "./DocumentsCreateFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d16c20",
  null
  
)

export default component.exports